import React, { useEffect, useState } from "react";
import { Loader } from "./Loader";
import styled from "styled-components/macro";
import { Button, IButtonProps } from "./Button";
import { t } from "../../utils/intl";

export const SendCalcButton: React.FC<IButtonProps> = props => {
  const { isLoading, hasError, textTrKey } = props;
  const [showDelayedInfo, setShowDelayedInfo] = useState(false);
  const [timerID, setTimerID] = useState(0);

  useEffect(() => {
    let timer = 0;
    setShowDelayedInfo(false);
    if (isLoading) {
      timer = (setTimeout(() => {
        setShowDelayedInfo(true);
      }, 3000) as unknown) as number;
      setTimerID(timer);
    } else if (timerID) {
      clearTimeout(timer);
    }

    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return (
    <SendButtonContainer>
      <Button buttonType={props.buttonType} disabled={props.disabled} onClick={props.onClick}>
        {t(textTrKey)}
      </Button>
      {hasError && <InvalidMessage>{t(`form.noCalculationPossible`)}</InvalidMessage>}
      <LoaderContainer>
        {isLoading && <Loader />}
        {showDelayedInfo && isLoading === true && (
          <InvalidMessage>{t(`form.CalcStillProgress`)}</InvalidMessage>
        )}
      </LoaderContainer>
    </SendButtonContainer>
  );
};

const SendButtonContainer = styled.div`
  margin-top: 44px;
  @media print {
    visibility: hidden;
  }

  button {
    min-width: 100%;
  }
`;

const InvalidMessage = styled.p`
  margin-top: 5px;
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.red};
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
